import { axiosV2 } from 'interceptors/axios';
import { Partner } from 'types';
import { decryptResponse } from 'utils/token';

type GetTradingOfferPartnerPublicInfoProps = {
  tradingOfferId: string;
  signal?: AbortSignal;
};

export type PartnerPublicInfo = Pick<
  Partner,
  '_id' | 'name' | 'image' | 'registerDate' | 'sharesCount'
>;

export const getTradingOfferPartnerPublicInfo = async ({
  tradingOfferId,
  // eslint-disable-next-line no-unused-vars
  signal,
}: GetTradingOfferPartnerPublicInfoProps): Promise<PartnerPublicInfo> => {
  const { data } = await axiosV2.get(
    `/tradingOffers/partner-public-info/${tradingOfferId}`
  );

  const decodedData = (await decryptResponse(data)) as PartnerPublicInfo;
  return decodedData;
};
